<template>
  <el-dialog
		title="快速添加SKU"
		:visible.sync="dialogShow"
		width="90%"
		height="90%"
    custom-class="iframedialog"
		top="5vh"
	>
    <el-table
      border
      style="width: 100%;margin-bottom:10px;"
      :header-cell-style="{ textAlign: 'center' }"
      :data="tableData"
    >
      <el-table-column label="订单号/订单ID">
        <template slot-scope="scope">
          <p v-show="scope.row.orderNumber">订单编码：{{ scope.row.orderNumber }}</p>
          <p>订单号：{{ scope.row.amazonOrderId }}</p>
          <p>订单ID：{{ scope.row.id }}</p>
          <p>平台：{{ platform[scope.row.seller.sellerType] || '其他' }}</p>
          <p>店铺：{{ scope.row.seller.shop_name }}</p>
          <p v-if="scope.row.shipmentBoxId !== null && scope.row.shipmentBoxId !== ''">运输编号：{{ scope.row.shipmentBoxId }}</p>
        </template>
      </el-table-column>

      <el-table-column align="left" label="产品信息">
        <template slot-scope="scope">
          <div
            class="details"
            v-for="(item, index) in scope.row.orderItems"
            :key="index"
          >
            <div class="details_left">
              <el-popover
                trigger="hover"
                placement="right"
                prop="orderItems.imageUrl"
                v-if="item.imageUrl"
              >
                <img
                  referrer="no-referrer|origin|unsafe-url"
                  :src="item.imageUrl"
                  alt
                  style="width:500px;height:500px;"
                />
                <div class="scope_img" slot="reference">
                  <img referrer="no-referrer|origin|unsafe-url" :src="item.imageUrl" alt />
                </div>
              </el-popover>
            </div>
            <div class="details_right">
              <div
                style="width: 100%;"
                v-if="scope.row.money == null"
              >
                <strong>price:</strong> - -
              </div>
              <div
                style="width: 100%;"
                v-if="scope.row.money !== null"
              >
                <strong style="color:black">price:</strong> {{ item.itemAmount }}
                {{ item.itemCurrencyCode }}
              </div>
              <div
                style="width: 100%;"
                v-if="item.property !== null"
              >
                <strong style="color:black">属性:</strong> {{ item.property }}
              </div>
              <div style="width: 100%;" v-show="item.systemSku">
                <strong style="color:black">系统SKU:</strong> {{ item.systemSku }}
              </div>
              <div style="width: 100%;">
                <strong style="color:black">SKU:</strong> {{ item.sellerSKU }}
              </div>
              <div style="width: 100%;" v-show="item.productSku">
                <strong style="color:black">产品SKU:</strong> {{ item.productSku }}
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <iframe class="iframebox" src="/#/box/SkuManagement?menuHide=0" frameborder="0"></iframe>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogShow = false">取 消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submit"
        >同 步</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
  import { ajaxPost, Baseurl } from '../../../api/api/api'
  export default {
    name: 'skuAdd',
    data() {
      return {
        dialogShow: false,
        platform: {2: 'shopify', 5: 'shoplazza', 7: 'shopline'},
        btnLoading: false
      }
    },
    methods: {
      init() {
        this.dialogShow = true
      },
      submit() {
        const API = Baseurl + '/systemProduct/syncMatch'
        let data = []
        this.tableData.map((item, i) => {
          data.push({
            orderId: item.amazonOrderId,
            sellerId: item.seller.sellerId,
            sellerType: item.seller.sellerType,
            items: []
          })
          item.orderItems.map(ele => {
            data[i].items.push({
              orderItemId: ele.orderItemId,
              sku: ele.sellerSKU,
              quantity: ele.quantityOrdered
            })
          })
        })
        this.btnLoading = true
        ajaxPost(API, data)
          .then((res) => {
            if(res.data.code === 200) {
              this.$message.success('同步成功')
              this.dialogShow = false
              this.$emit('reload')
            }else{
              this.$message.error(res.data.message)
            }
            this.btnLoading = false
          })
      }
    },
    props: {
      tableData: Array
    }
  }
</script>

<style lang="scss" scoped>
/deep/.iframedialog {
  min-height: 90%;
  .el-dialog__body {
    height: 100%;
  }
}
.iframebox {
  width: calc(100% - 2px);
  height: 700px;
  border: 1px solid #EBEEF5;
  box-sizing: border-box;
}
.RRR {
	color: red;
}
.FBMOrder {
	width: 98%;
	position: relative;

	.custom-formScreen {
		::v-deep {
			.el-form-item__content {
				width: calc(100% - 120px);
			}
		}
	}
	.el-table {
		font-size: 12px;
	}
	.FBMOrder_top {
		overflow: hidden;
		border-bottom: 1px #eee solid;
		h3 {
			float: left;
			margin-bottom: 20px;
		}
		div {
			float: right;
		}
	}
	.el-tag--dark {
		border: 0;
	}
	::v-deep {
		.el-form-item__label {
			width: 120px;
			// text-align: center;
		}
	}
	.order_list {
		position: relative;
		// overflow: hidden;
		.search-result {
			overflow: hidden;
			background: #f9f3f3;
			.right {
				float: right;
			}
		}
		.search-result-text {
			font-size: 14px;
			color: #606266;
			width: 230px;
			line-height: 40px;
			float: left;
			span {
				color: #f56c6c;
				font-size: 16px;
			}
		}
		.cell {
			.scope_img {
				display: initial;
			}
		}
	}
	.el-table {
		overflow: initial;
	}
	.el-table__body-wrapper {
		overflow: initial;
	}
	a {
		color: #409eff;
	}
	.details {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.details_left {
		width: 30%;
		text-align: center;
	}
	.details_right {
		width: 70%;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}
	.page {
		position: fixed;
		width: 100%;
		bottom: 0;
		background-color: white;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 50px;
		z-index: 99;
	}
	.scope_img img {
		width: 55px;
		height: 55px;
	}
	.Memo {
		width: 25px;
		height: 25px;
	}
	.Memo1 {
		width: 17px;
		height: 19px;
	}
	.search-result.oh /deep/ .el-button+.el-button {
		margin-right: 0.48828vw;
	}
}
</style>